export enum SpinnerType {
    BallAtom = "s1",
    BallScaleMultiple = "s2",
    BallSpinClockwiseFadeRotating = "s3"
  }

